import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  constructor() {}

  @Input() class: string='';
  @Input() module_header: boolean=true;

  ngOnInit(): void {
  }
}
